// Point d'entrée du front : thème posé avant le rendu, session, routes. Sans session : connexion ;
// mot de passe provisoire : changement forcé quelle que soit l'URL ; /admin réservé aux admins.
import { lazy, StrictMode, Suspense, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import './styles.css';
import './admin.css';
import { AccountPage } from './pages/Account.tsx';
import { CreatePage } from './pages/Create.tsx';
import { LinksPage } from './pages/Links.tsx';
import { ChangePasswordPage, LoginPage } from './pages/Login.tsx';
import { WindowsPage } from './pages/Windows.tsx';
import { SessionProvider, useSession } from './session.tsx';
import { initTheme } from './theme.ts';
import { Loading } from './ui.tsx';

// Chargés à la demande : la carte (Leaflet) et l'administration (ajv pour l'éditeur).
const PlacesPage = lazy(() => import('./pages/Places.tsx').then((module) => ({ default: module.PlacesPage })));
const AccountsPage = lazy(() => import('./pages/admin/Accounts.tsx').then((module) => ({ default: module.AccountsPage })));
const TemplatesPage = lazy(() => import('./pages/admin/Templates.tsx').then((module) => ({ default: module.TemplatesPage })));
const SupervisionPage = lazy(() => import('./pages/admin/Supervision.tsx').then((module) => ({ default: module.SupervisionPage })));
const SettingsPage = lazy(() => import('./pages/admin/Settings.tsx').then((module) => ({ default: module.SettingsPage })));

function Gate() {
  const { account } = useSession();
  if (account === undefined) return <Loading />;
  if (account === null) return <LoginPage />;
  if (account.mustChangePassword) return <ChangePasswordPage />;
  const admin = (page: ReactNode) => (account.role === 'admin' ? page : <Navigate to="/" replace />);
  return (
    <Suspense fallback={<Loading />}>
    <Routes>
      <Route path="/" element={<WindowsPage />} />
      <Route path="/creer" element={<CreatePage />} />
      <Route path="/lieux" element={<PlacesPage />} />
      <Route path="/liens" element={<LinksPage />} />
      <Route path="/compte" element={<AccountPage />} />
      <Route path="/admin" element={admin(<AccountsPage />)} />
      <Route path="/admin/templates" element={admin(<TemplatesPage />)} />
      <Route path="/admin/supervision" element={admin(<SupervisionPage />)} />
      <Route path="/admin/reglages" element={admin(<SettingsPage />)} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </Suspense>
  );
}

initTheme();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SessionProvider>
      <BrowserRouter>
        <Gate />
      </BrowserRouter>
    </SessionProvider>
  </StrictMode>,
);
